/* ANGE Projects — mobile sticky Add to cart bar
   Visible immediately on mobile page load. Hides ("merges") once the real
   product-form buttons scroll into view; reappears if the user scrolls
   back up above them. Mirrors label / disabled state and the live price,
   and proxies clicks to the real button so all existing variant
   validation and AJAX add-to-cart logic is reused as-is. The size
   selector opens its own panel in place (no scrolling away) and writes
   directly to the real underlying <select>, which stays the single
   source of truth for the actual variant selection.

   ANGE: price source. The price shown in the bar (right side, opposite "Add to cart") is
   taken from the price on the main Add to cart button (.product-form__submit-price), or, if
   that is empty (e.g. while sold out), from the price next to the product title
   (.product__title-price). The theme's original price field (#price-...) is always empty on
   this product page (the price moved next to the title), so copying it used to leave the bar
   without a price.

   ANGE: footer. The bar also hides while the site footer is in view, so it never covers
   the footer (newsletter sign-up, payment icons, country selector). */
(function () {
  function initStickyAtc(root) {
    // Reparent to <body>. This element is rendered inside
    // .product__info-wrapper, which gets a CSS transform when scroll-reveal
    // animations are enabled — and any ancestor transform breaks
    // position:fixed (it re-anchors to that ancestor instead of the
    // viewport). Moving it out of that subtree guarantees it's always
    // truly fixed to the screen, not trapped inline in the page flow.
    if (root.parentElement !== document.body) {
      document.body.appendChild(root);
    }

    var targetButtonId = root.dataset.targetButton;
    var targetButton = document.getElementById(targetButtonId);
    var titlePrice = document.querySelector('.product__title-price');
    var stickyButton = root.querySelector('[data-sticky-atc-button]');
    var stickyPrice = root.querySelector('.sticky-atc__price');
    var sizeRow = root.querySelector('[data-sticky-atc-size-row]');
    var stickySizeTrigger = root.querySelector('[data-sticky-atc-size]');
    var stickySizeLabel = root.querySelector('[data-sticky-atc-size-label]');
    var stickySizePanel = root.querySelector('[data-sticky-atc-size-panel]');
    var defaultAddLabel = stickyButton
      ? stickyButton.querySelector('span').textContent.trim()
      : 'Add to cart';

    if (!targetButton) return;

    function syncPrice() {
      if (!stickyPrice) return;
      var buttonPrice = targetButton.querySelector('.product-form__submit-price');
      var text = (buttonPrice && buttonPrice.textContent.trim()) || (titlePrice && titlePrice.textContent.trim()) || '';
      if (text && stickyPrice.textContent.trim() !== text) {
        stickyPrice.textContent = text;
      }
    }

    function syncButtonState() {
      if (!stickyButton) return;

      if (targetButton.hasAttribute('disabled')) {
        stickyButton.setAttribute('disabled', 'disabled');
      } else {
        stickyButton.removeAttribute('disabled');
      }

      // Read the dedicated label-only span (added by the price-label
      // customization on the real button). Do NOT fall back to the
      // button's first generic <span> — that one now wraps BOTH the
      // label and the price together, and .textContent on a wrapper
      // concatenates all of its descendants' text with no separator
      // (e.g. "Add to cart" + "€150" -> "Add to cart€150").
      var realLabelSpan = targetButton.querySelector('.product-form__submit-label');
      var stickyLabel = stickyButton.querySelector('span');
      if (stickyLabel) {
        stickyLabel.textContent = (realLabelSpan && realLabelSpan.textContent.trim())
          ? realLabelSpan.textContent
          : defaultAddLabel;
      }

      if (targetButton.classList.contains('button--secondary')) {
        stickyButton.classList.add('button--secondary');
        stickyButton.classList.remove('button--primary');
      } else {
        stickyButton.classList.add('button--primary');
        stickyButton.classList.remove('button--secondary');
      }

      var computed = window.getComputedStyle(targetButton);
      stickyButton.style.setProperty('background-color', computed.backgroundColor);
      stickyButton.style.setProperty('background-image', computed.backgroundImage);
      stickyButton.style.setProperty('color', computed.color);
      stickyButton.style.setProperty('border-color', computed.borderColor);
      stickyButton.style.setProperty('border-width', computed.borderWidth);
      stickyButton.style.setProperty('border-style', computed.borderStyle);

      syncPrice();
    }

    function getRealSelect() {
      return document.querySelector('.product-form__input--dropdown select');
    }

    function closeSizePanel() {
      if (!sizeRow || !stickySizePanel) return;
      sizeRow.classList.remove('is-open');
      stickySizePanel.hidden = true;
    }
    function openSizePanel() {
      if (!sizeRow || !stickySizePanel) return;
      sizeRow.classList.add('is-open');
      stickySizePanel.hidden = false;
    }

    function buildSizePanel() {
      var realSelect = getRealSelect();
      if (!stickySizePanel || !realSelect) return;
      stickySizePanel.innerHTML = '';
      Array.from(realSelect.options).forEach(function (opt) {
        if (!opt.value) return;
        var row = document.createElement('button');
        row.type = 'button';
        row.className = 'sticky-atc__size-option';
        if (opt.disabled) row.classList.add('is-disabled');
        row.textContent = opt.textContent.trim();
        row.addEventListener('click', function () {
          if (opt.disabled) return;
          realSelect.value = opt.value;
          realSelect.dispatchEvent(new Event('change', { bubbles: true }));
          closeSizePanel();
        });
        stickySizePanel.appendChild(row);
      });
    }

    // Only updates the label AFTER a genuine selection (via the real
    // select's 'change' event) — never reflects whatever variant Dawn
    // silently auto-selects behind the scenes on page load.
    function syncSizeLabelFromRealSelect() {
      var realSelect = getRealSelect();
      if (!stickySizeLabel || !realSelect) return;
      var opt = realSelect.options[realSelect.selectedIndex];
      stickySizeLabel.textContent = (opt && opt.value) ? opt.textContent.trim() : 'Select a Size';
      buildSizePanel();
    }

    if (stickySizeLabel) stickySizeLabel.textContent = 'Select a Size';
    syncButtonState();
    buildSizePanel();

    // Watches the real button (disabled state, label AND its price span), so the bar's
    // label, colours and price always follow it.
    new MutationObserver(syncButtonState).observe(targetButton, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
      characterData: true,
    });

    if (titlePrice) {
      new MutationObserver(syncPrice).observe(titlePrice, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    var realSelectInit = getRealSelect();
    if (realSelectInit) {
      realSelectInit.addEventListener('change', syncSizeLabelFromRealSelect);
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        targetButton.click();
      });
    }

    if (stickySizeTrigger) {
      stickySizeTrigger.addEventListener('click', function () {
        if (stickySizePanel.hidden) {
          buildSizePanel();
          openSizePanel();
        } else {
          closeSizePanel();
        }
      });
      document.addEventListener('click', function (e) {
        if (sizeRow && !sizeRow.contains(e.target)) closeSizePanel();
      });
    }

    // The bar hides while EITHER the real Add to cart button OR the site footer is in view.
    var buttonInView = false;
    var footerInView = false;

    function updateVisibility() {
      if (buttonInView || footerInView) {
        root.classList.add('is-hidden');
        closeSizePanel();
      } else {
        root.classList.remove('is-hidden');
      }
    }

    var visibilityObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          buttonInView = entry.isIntersecting;
        });
        updateVisibility();
      },
      { threshold: 0 }
    );
    visibilityObserver.observe(targetButton);

    var footerEl = document.querySelector('footer.footer') || document.querySelector('footer');
    if (footerEl) {
      var footerObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            footerInView = entry.isIntersecting;
          });
          updateVisibility();
        },
        { threshold: 0 }
      );
      footerObserver.observe(footerEl);
    }
  }

  document.querySelectorAll('[data-sticky-atc]').forEach(initStickyAtc);
})();
